function TitleComponent({ titles }) {
  return (
    <div className="base-container">
      <h2 className="base-title text-center">TITOLI NAZIONALI</h2>
      {titles.map((title, index) => (
        <div key={index}>
          <span className="base-text">{title.title}</span>
          <span className="base-text"> - </span>
          <span className="base-text">{title.athleteName}</span>
        </div>
      ))}
    </div>
  );
}

export default TitleComponent;
